
import { Component, OnInit } from '@angular/core';
import { OrdemServicoService } from '../../../services/ordemSerico.service';
import { UsuarioService } from '../../../services/usuario.service';

@Component({
  selector: 'app-cliente-base',
  standalone: false,
  templateUrl: './cliente-base.component.html',
  styleUrl: './cliente-base.component.css'
})
export class ClienteBaseComponent implements OnInit {
  colaboradores: any[] = [];
  colaboradorSelecionado: string = '';

  mensagemSucesso: string = '';
  isDistribuindo: boolean = false;

  allSelected = false;
  allSelectedRecadastros = false;
  showFiltros: boolean = false;
  searchFields = {
    nome: '',
    cpf: '',
    matricula: '',
    numeroOS: '',
    cep: '',
    logradouro: '',
    bairro: '',
    cidade: '',
    estado: '',
    numero: ''
  };

  loading: boolean = false;
  error: string = '';
  clientes: any[] = [];
  recadastros: any[] = [];
  totalItens: number = 0;
  paginaAtual: number = 1;
  totalPaginas: number = 1;
  tamanhoPagina: number = 50;
  // número máximo de botões de página a mostrar (inclui 1 e última)
  maxPageButtons: number = 7;

  // Ordenação: padrão solicitado (NomeConsumidor = 0, Direcao Asc = 0)
  ordenarPor: number = 0;
  direcao: number = 0;

  constructor(
    private ordemServicoService: OrdemServicoService,
    private usuarioService: UsuarioService
  ) { }

  ngOnInit(): void {
    this.applyFilters();
    this.usuarioService.carregarTodosColaboradores().subscribe(colabs => {
      this.colaboradores = colabs || [];
    });
  }

  toggleSelectAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.allSelected = checked;
    if (this.clientes) {
      this.clientes.forEach((c: any) => c.selected = checked);
    }
  }

  toggleSort(column: number) {
    if (this.ordenarPor === column) {
      this.direcao = this.direcao === 0 ? 1 : 0;
    } else {
      this.ordenarPor = column;
      this.direcao = 0; // asc por padrão ao mudar coluna
    }
    this.applyFilters(this.paginaAtual);
  }

  getSortIcon(column: number): string {
    if (this.ordenarPor !== column) return 'fas fa-sort';
    return this.direcao === 0 ? 'fas fa-arrow-down' : 'fas fa-arrow-up';
  }

  atribuirSelecionados() {
    // coletar selecionados apenas de clientes (que já contém cadastros + recadastros)
    const selecionados = this.clientes.filter((c: any) => c.selected) || [];
    if (!this.colaboradorSelecionado || selecionados.length === 0) {
      alert('Selecione pelo menos um cliente e um colaborador.');
      return;
    }
    let sucesso = 0;
    let erros = 0;
    let total = selecionados.length;
    let finalizado = 0;
    // ligar indicador global de distribuição (spinner / estado do botão)
    this.isDistribuindo = true;
    selecionados.forEach((cliente: any) => {
      const cadastroId = cliente.cadastroId || '';
      const recadastroId = cliente.recadastroId || cliente.reCadastroId || '';
      const ordemServicoId = cliente.ordemServicoId ?? cliente.OrdemServicoId ?? cliente.ordemServicoID ?? cliente.id ?? '';
      const matricula = cliente.matricula ?? cliente.Matricula ?? cliente.matriculaConsumidor ?? '';
      const status = cliente.status ?? cliente.Status ?? '';
      const statusOS = cliente.statusOS ?? cliente.StatusOS ?? cliente.status_os ?? '';

      this.ordemServicoService.distribuirOrdemServico(
        this.colaboradorSelecionado,
        cadastroId,
        recadastroId,
        ordemServicoId,
        matricula,
        status,
        statusOS
      ).subscribe({
        next: (res) => {
          if (res) sucesso++;
          else erros++;
          finalizado++;
          if (finalizado === total) {
            if (sucesso > 0) {
              this.mensagemSucesso = `Atribuição realizada com sucesso para ${sucesso} cliente(s).` + (erros > 0 ? ` (${erros} falha(s))` : '');
            } else {
              this.mensagemSucesso = '';
            }
            this.applyFilters();
            this.isDistribuindo = false;
          }
        },
        error: () => {
          erros++;
          finalizado++;
          if (finalizado === total) {
            if (sucesso > 0) {
              this.mensagemSucesso = `Atribuição realizada com sucesso para ${sucesso} cliente(s).` + (erros > 0 ? ` (${erros} falha(s))` : '');
            } else {
              this.mensagemSucesso = '';
            }
            this.applyFilters();
            this.isDistribuindo = false;
          }
        }
      });
    });
  }

  applyFilters(pagina: number = 1) {
    this.showFiltros = false;
    this.loading = true;
    this.error = '';
    // SEMPRE enviar paginação, mesmo com filtros
    this.ordemServicoService.naoAtribuidos(
      pagina,
      this.tamanhoPagina,
      this.searchFields.nome,
      this.searchFields.cpf,
      this.searchFields.matricula,
      undefined,
      this.searchFields.cep,
      this.searchFields.logradouro,
      this.searchFields.bairro,
      this.searchFields.cidade,
      this.searchFields.estado,
      this.searchFields.numero,
      this.searchFields.numeroOS,
      undefined,
      this.ordenarPor,
      this.direcao
    ).subscribe({
      next: (res) => {
        this.loading = false;

        const todos = res?.itens || [];

        // A API agora faz as validações/filtragens por status.
        // Aqui separamos cadastros e recadastros apenas pela presença de identificadores de recadastro
        const recadastrosCandidatos = todos.filter((cliente: any) => !!cliente.recadastroId || !!cliente.reCadastroId || !!cliente.isRecadastro);

        // Cadastros são os itens que não são recadastro (se a API não indicar o contrário)
        const cadastroFiltrados = todos.filter((cliente: any) => !(!!cliente.recadastroId || !!cliente.reCadastroId || !!cliente.isRecadastro));

        // evitar duplicados que já estejam na lista de cadastro
        const idsCadastro = new Set(cadastroFiltrados.map((c: any) => c.ordemServicoId ?? c.OrdemServicoId ?? c.id ?? ''));
        this.recadastros = recadastrosCandidatos.filter((c: any) => !(idsCadastro.has(c.ordemServicoId ?? c.OrdemServicoId ?? c.id ?? '')));

        // Mostrar todos os itens retornados (cadastros + recadastros) na mesma lista
        // Antes apenas `cadastroFiltrados` era exibido, deixando fora muitos itens que a API devolveu.
        this.clientes = [...cadastroFiltrados, ...this.recadastros];

        // Ajustar totalItens/paginação.
        // Preferir os metadados que a API devolve (totalItens, paginaAtual, totalPaginas).
        // Caso a API não retorne esses campos, usar cálculo local como fallback.
        this.totalItens = (res && (res.totalItens || res.totalItens === 0)) ? res.totalItens : cadastroFiltrados.length;

        // totalPaginas preferido vindo da API, senão calcular localmente
        this.totalPaginas = (res && (res.totalPaginas || res.totalPaginas === 0)) ? Math.max(1, res.totalPaginas) : Math.max(1, Math.ceil(this.totalItens / this.tamanhoPagina));

        // paginaAtual: preferir valor da API, garantindo que esteja dentro de 1..totalPaginas
        const apiPagina = res?.paginaAtual ?? pagina;
        this.paginaAtual = Math.min(Math.max(1, apiPagina), this.totalPaginas);
      },
      error: (err) => {
        this.loading = false;
        this.error = 'Erro ao buscar clientes.';
        this.clientes = [];
      }
    });
  }

  

  clearFilters() {
    this.searchFields = {
      nome: '',
      cpf: '',
      matricula: '',
      numeroOS: '',
      cep: '',
      logradouro: '',
      numero: '',
      bairro: '',
      cidade: '',
      estado: ''
    };
    this.showFiltros = false;
    this.applyFilters();
  }

  loadAllClientes() {
    this.applyFilters();
  }

  mudarPagina(pagina: number | string) {
    const p = Number(pagina);
    if (isNaN(p)) return;
    if (p < 1 || p > this.totalPaginas) return;
    this.paginaAtual = p;
    this.applyFilters(p);
  }

  getVisiblePageNumbers(): Array<number | string> {
    const total = Math.max(1, this.totalPaginas || 1);
    const current = Math.min(Math.max(1, this.paginaAtual || 1), total);
    const maxButtons = Math.max(5, this.maxPageButtons || 7); // garantir ao menos 5

    // Se o total for pequeno, mostrar todas
    if (total <= maxButtons) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages: Array<number | string> = [];
    const side = Math.floor((maxButtons - 3) / 2); // reservamos 3 posições (primeira, última e pelo menos um buffer)

    let start = Math.max(2, current - side);
    let end = Math.min(total - 1, current + side);

    // ajustar se aproximando das bordas
    if (current - start < side) {
      end = Math.min(total - 1, end + (side - (current - start)));
    }
    if (end - current < side) {
      start = Math.max(2, start - (side - (end - current)));
    }

    pages.push(1);
    if (start > 2) pages.push('...');
    for (let p = start; p <= end; p++) pages.push(p);
    if (end < total - 1) pages.push('...');
    pages.push(total);

    return pages;
  }

  // Índice do primeiro item mostrado nesta página (1-based)
  getStartItem(): number {
    if (!this.totalItens) return 0;
    return Math.min(this.totalItens, (this.paginaAtual - 1) * this.tamanhoPagina + 1);
  }

  // Índice do último item mostrado nesta página (1-based)
  getEndItem(): number {
    if (!this.totalItens) return 0;
    return Math.min(this.totalItens, this.paginaAtual * this.tamanhoPagina);
  }

  // Muda o tamanho da página e volta para a página 1
  mudarTamanhoPagina(novoTamanho: number | string) {
    const size = Number(novoTamanho) || 5;
    this.tamanhoPagina = size;
    this.mudarPagina(1);
  }

  // Pular para página a partir do input
  // (campo "Ir para" removido do template)  

  formatCpf(cpf: string): string {
    if (!cpf) return '';
    const digits = String(cpf).replace(/\D/g, '');
    if (digits.length !== 11) return cpf;
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  // Compatibilidade com template antigo que chama formatDocumento()
  private formatCnpj(cnpj: string): string {
    if (!cnpj) return '';
    const digits = String(cnpj).replace(/\D/g, '');
    if (digits.length !== 14) return cnpj;
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  formatDocumento(doc: string): string {
    if (doc == null || doc === '') return '';
    const raw = String(doc).replace(/\s+/g, '');
    const digits = raw.replace(/\D/g, '');
    if (!digits) return raw || '';
    if (digits.length === 11) return this.formatCpf(digits);
    if (digits.length === 14) return this.formatCnpj(digits);
    // se não for CPF/CNPJ, devolve o valor original (p.ex. já formatado)
    return raw;
  }

  formatAddress(cliente: any): string {
    if (!cliente.endereco) return '';
    const e = cliente.endereco;
    return `${e.rua || ''}, ${e.bairro || ''}, ${e.cidade || ''}, ${e.municipio || ''}, ${e.cep || ''}`.replace(/(, )+/g, ', ').replace(/^, |, $/g, '');
  }

  irParaEdicao(cliente: any) {
    // Lógica de navegação para edição
    const nome = cliente.nomeConsumidor || cliente.nome || '-';
    alert('Ir para edição do cliente: ' + nome);
  }

  temSelecionado(): boolean {
    const selCadastro = this.clientes && this.clientes.some((c: any) => c.selected);
    const selRecad = this.recadastros && this.recadastros.some((c: any) => c.selected);
    return !!selCadastro || !!selRecad;
  }

  toggleRowSelection(cliente: any, event: MouseEvent): void {
    // Prevent toggling if the click was on the checkbox itself
    if (!(event.target as HTMLElement).closest('input[type="checkbox"]')) {
      cliente.selected = !cliente.selected;
    }
  }

  toggleSelectAllRecadastros(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.allSelectedRecadastros = checked;
    if (this.recadastros) {
      this.recadastros.forEach((c: any) => c.selected = checked);
    }
  }
}